module.exports = __webpack_public_path__ + "img/rio-verde.018d1f0f.png";